import { AlertCircle, BrainCircuit, HelpCircle, ShieldAlert, Sparkles } from "lucide-react";
import { askAssistant } from "./AssistantPanel";

type InlineHelpProps = {
  label?: string;
  prompt: string;
  tone?: "plain" | "danger";
};

export function AiInlineHelp({ label = "问 AI", prompt, tone = "plain" }: InlineHelpProps) {
  const Icon = tone === "danger" ? ShieldAlert : HelpCircle;
  return <button type="button" className={`ai-inline-help ${tone}`} onClick={() => askAssistant(prompt)} title={label} aria-label={label}>
    <Icon size={13} /><span>{label}</span>
  </button>;
}

export function AiExplainError({ message, context }: { message: string; context: string }) {
  return <button type="button" className="ai-inline-help danger" onClick={() => askAssistant(`我在「${context}」遇到这个报错：${message}。请用小白能懂的话解释它是什么意思、最常见原因、我应该先检查哪里、哪些按钮现在不要乱点。`)}>
    <AlertCircle size={13} /><span>解释报错</span>
  </button>;
}

export function AiRiskCheck({ action, detail }: { action: string; detail: string }) {
  return <button type="button" className="ai-risk-check" onClick={() => askAssistant(`我准备执行「${action}」。背景：${detail}。请像带小白操作一样说明：这个动作会影响什么、执行前检查哪几项、什么时候不能点、执行后怎么看成功。只解释风险，不替我操作。`)}>
    <Sparkles size={13} /><span>先问 AI 风险</span>
  </button>;
}

export function AiDecisionCheck({ action, detail }: { action: string; detail: string }) {
  return <button type="button" className="ai-decision-check" onClick={() => askAssistant(`请帮我对「${action}」做辅助决策。当前情况：${detail}。请按这个格式回答：1）建议：可以做 / 暂缓 / 不建议；2）理由：用小白能懂的话说明；3）风险等级：高/中/低；4）执行前必须检查什么；5）下一步我该点哪里；6）帮我生成一段可复制的操作原因。注意：你只做决策建议，不替我执行。`)}>
    <BrainCircuit size={13} /><span>AI 帮我判断</span>
  </button>;
}
